import script from "./HeadingPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./HeadingPanel.vue?vue&type=script&setup=true&lang=js"

import "./HeadingPanel.vue?vue&type=style&index=0&id=327d5731&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/blueshift-vesting-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-327d5731"]])

export default __exports__